export default "Bliv klog på fisk! Undersøg en fisk både udvendig og indvendig og bliv klogere på fiskens udseende og indre organer.  ";